function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1054B8",
  d: "M38.91 28.6c1.24 0 2.24.98 2.24 2.2 0 1.21-1 2.2-2.24 2.2a2.22 2.22 0 01-2.24-2.2c0-1.21 1-2.2 2.24-2.2zm-8.95-22c1.23 0 2.23.98 2.23 2.19v22.02c0 1.21-1 2.19-2.23 2.19a2.21 2.21 0 01-2.24-2.19V8.79c0-1.21 1-2.19 2.24-2.19zM21 13.2c1.24 0 2.24.98 2.24 2.2v15.4c0 1.22-1 2.2-2.24 2.2a2.22 2.22 0 01-2.24-2.2V15.4c0-1.22 1-2.2 2.24-2.2zm-8.96 6.6c1.24 0 2.24.98 2.24 2.19v8.82c0 1.21-1 2.19-2.24 2.19a2.21 2.21 0 01-2.23-2.19V22c0-1.21 1-2.19 2.23-2.19zM3.1 26.4a2.2 2.2 0 012.24 2.16v2.28c0 1.2-1 2.16-2.24 2.16a2.2 2.2 0 01-2.24-2.16v-2.28c0-1.2 1-2.16 2.24-2.16zM38.9 0c1.24 0 2.24.98 2.24 2.2v22c0 1.2-1 2.19-2.24 2.19a2.22 2.22 0 01-2.24-2.2v-22c0-1.2 1-2.19 2.24-2.19z"
});

function SvgAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 33,
    fill: "none",
    viewBox: "0 0 42 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.5139beb5.svg";
export { ForwardRef as ReactComponent };